import { useAnalytics } from '#app/hooks/useAnalytics.js';
import { useCurrentRouteKey } from '#app/hooks/useCurrentRouteKey.js';
import { useCurrentUser } from '#app/hooks/useCurrentUser.js';
import { useFirstReferrerUrl } from '#app/hooks/useFirstReferrerUrl.js';
import { useLastLocation } from '#app/hooks/useLastLocation.js';
import { useLocation } from '#app/hooks/useLocation.js';
import { prettifyRouteKey } from '#app/utilities/prettifyRouteKey.js';
import { useEffect } from 'react';

export const PageViewTracker = () => {
  const { track } = useAnalytics();
  const location = useLocation();
  const currentRouteKey = useCurrentRouteKey();
  const lastLocation = useLastLocation();
  const currentUser = useCurrentUser();
  const firstReferrerUrl = useFirstReferrerUrl();

  const referrer = lastLocation?.currentURL ?? (firstReferrerUrl || undefined);

  useEffect(() => {
    track('page', {
      action: 'viewed',
      is_authenticated: Boolean(currentUser),
      name: prettifyRouteKey(currentRouteKey),
      path: location.path,
      referrer,
      search: location.search ?? '',
      title: document.title ?? '',
      url: location.currentURL,
    });
    // It is unsafe to track other properties because it may result in double registering page view, e.g.
    // `track` mutates every time `featureFlags` changes.
  }, [location]);

  return null;
};
